export default __webpack_public_path__ + "static/leather-ca57599eec053e8ef9206060a6c863be.jpg";